import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import { useMemo, useState } from 'react';
import { ColDef } from 'ag-grid-community';
import { ComponentErrorBoundary } from '@app/utilities';

export function Table<T>({
  items,
  onSelectItem = () => {},
  columnDefs,
  noFilter = false,
  ...props
}: AgGridReactProps<T> & {
  items: T[];
  onSelectItem?: (item: T) => void;
  columnDefs: ColDef[];
  noFilter?: boolean;
}) {
  return (
    <ComponentErrorBoundary>
      <AgGrid
        rowData={items}
        columnDefs={columnDefs}
        onRowClicked={(e) => onSelectItem(e?.data)}
        noFilter={noFilter}
        {...props}
      />
    </ComponentErrorBoundary>
  );
}

function AgGrid<T>({
  defaultColDef,
  noFilter,
  ...props
}: AgGridReactProps<T> & {
  noFilter?: boolean;
}) {
  const [filter, setFilter] = useState('' as string);
  const defaultColDefs: ColDef = useMemo(() => {
    return {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 150,
      flex: 1,
      ...(defaultColDef ?? {}),
    };
  }, [defaultColDef]);

  return (
    <ComponentErrorBoundary>
      {!noFilter && (
        <div className={'ui form'}>
          <div className={'ui field'}>
            <div className="ui input labeled">
              <span className={'ui label'}>Quick Filter:</span>
              <input
                type="text"
                placeholder="Filter..."
                className={'ui input'}
                onChange={(e) => setFilter(e.target.value)}
              />
            </div>
          </div>
        </div>
      )}
      <div style={{ height: '100%' }} className="ag-theme-quartz">
        <AgGridReact
          defaultColDef={defaultColDefs}
          rowSelection={'single'}
          quickFilterMatcher={(quickFilterParts: string[], rowQuickFilterAggregateText: string) => {
            return rowQuickFilterAggregateText.indexOf(quickFilterParts.join(' ')) !== -1;
          }}
          quickFilterText={filter}
          getRowStyle={(params) => {
            let style = {};
            if (params.node.rowIndex % 2 === 0) {
              style = { background: '#f7f8fc' };
            }
            if (params.node.isSelected()) {
              style = { background: '#c7e0f4' };
            }
            return style;
          }}
          {...props}
        />
      </div>
    </ComponentErrorBoundary>
  );
}
